import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { hero } from "@/lib/home-content";
import { scrollToId } from "@/lib/scroll";

export default function Hero() {
    return (
        <section id="top" data-testid="hero-section" className="bg-lavender relative overflow-hidden pt-32 sm:pt-40">
            <div className="mx-auto max-w-6xl px-5 pb-10 sm:pb-14">
                <div className="mb-8 flex flex-wrap items-center justify-between gap-3 text-[11px] font-semibold uppercase tracking-[0.16em] text-[#8a8a95]">
                    <span className="inline-flex items-center gap-2">
                        <span className="h-1.5 w-1.5 rounded-full bg-[var(--brand)]" />
                        {hero.kicker}
                    </span>
                    <span className="hidden sm:inline">{hero.meta}</span>
                </div>

                <h1
                    data-testid="hero-headline"
                    className="max-w-5xl font-display text-[2.6rem] font-extrabold leading-[1.04] tracking-tight text-[#0a0a0b] sm:text-6xl lg:text-7xl"
                >
                    We build <span className="text-[#ff6b8a]">AI-powered</span>{" "}
                    <span className="text-[#c026d3]">SaaS, websites &amp;</span>{" "}
                    <span className="text-[var(--brand)]">automation</span> real businesses run on.
                </h1>

                <p className="mt-6 max-w-3xl text-[15px] leading-relaxed text-[#5b5b66] sm:text-lg">
                    {hero.subtitle}
                </p>

                <div className="mt-8 flex flex-wrap items-center gap-3">
                    <button
                        type="button"
                        data-testid="hero-book-consultation-button"
                        onClick={() => scrollToId("#contact")}
                        className="group inline-flex items-center justify-center gap-2 rounded-full bg-[#0a0a0b] px-6 py-3 text-sm font-semibold text-white transition-transform hover:-translate-y-0.5"
                    >
                        {hero.primaryCta}
                        <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5" />
                    </button>
                    <Link
                        to="/products"
                        data-testid="hero-see-products"
                        className="inline-flex items-center justify-center rounded-full bg-white px-6 py-3 text-sm font-semibold text-[#0a0a0b] ring-1 ring-black/10 hover:text-[var(--brand)]"
                    >
                        {hero.secondaryCta}
                    </Link>
                </div>

                <button
                    type="button"
                    data-testid="hero-meter-link"
                    onClick={() => scrollToId("#cost-meter")}
                    className="mt-8 text-sm font-semibold text-[#0a0a0b] underline decoration-black/30 underline-offset-4 hover:text-[var(--brand)]"
                >
                    {hero.meterCta}
                </button>
            </div>
        </section>
    );
}
